import { render } from "./settings.vue?vue&type=template&id=99890444"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"

import "./settings.vue?vue&type=style&index=0&id=99890444&lang=css"
script.render = render

export default script